import { render, staticRenderFns } from "./AFechaContacto.vue?vue&type=template&id=977328a0"
import script from "./AFechaContacto.vue?vue&type=script&lang=js"
export * from "./AFechaContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports